import MotorsTablet from './motors.desktop';

export default MotorsTablet;
